/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductInput } from '../../models/product-input';
import { ProductResponse } from '../../models/product-response';

export interface TenantsTenantIdCatalogEntriesProductsPost$Params {
  tenantId: string;
      body: ProductInput
}

export function tenantsTenantIdCatalogEntriesProductsPost(http: HttpClient, rootUrl: string, params: TenantsTenantIdCatalogEntriesProductsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductResponse>> {
  const rb = new RequestBuilder(rootUrl, tenantsTenantIdCatalogEntriesProductsPost.PATH, 'post');
  if (params) {
    rb.path('tenantId', params.tenantId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProductResponse>;
    })
  );
}

tenantsTenantIdCatalogEntriesProductsPost.PATH = '/tenants/{tenantId}/catalog-entries/products';
